import {useCallback, useSyncExternalStore} from 'react';

import {readTagsSortMode, TagsSortMode, writeTagsSortMode} from '../lib/tagsSort';

export interface IUseTagsSort {
    mode: TagsSortMode,
    changeMode: (_mode: TagsSortMode) => void,
}

const listeners = new Set<() => void>();

const subscribe = (listener: () => void): (() => void) => {
    listeners.add(listener);

    return () => {
        listeners.delete(listener);
    };
};

const useTagsSort = (): IUseTagsSort => {
    const mode = useSyncExternalStore(subscribe, readTagsSortMode);

    const changeMode = useCallback((next: TagsSortMode) => {
        writeTagsSortMode(next);
        listeners.forEach((listener) => listener());
    }, []);

    return {mode, changeMode};
};

export default useTagsSort;
